<template>
  <button type="button" :class="className">
    <slot />
  </button>
</template>

<script>
export default {
  name: "NamedCartsButton",
  props: {
    variant: {
      type: String,
      default: ""
    }
  },
  computed: {
    className() {
      return `named-carts-button named-carts-button--${this.variant}`;
    }
  }
};
</script>

<style scoped lang="scss">
@import "frontend/init/jiffy/settings";

.named-carts-button {
  display: inline-block;
  appearance: none;
  padding: 6px 16px;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: $link-blue;
  border: 1px solid $gray-border;
  border-radius: 12px;
  background: $white;
  cursor: pointer;

  &:hover {
    background: $section-grey;
    box-shadow: 0 2px 5px $gray-section;
  }

  &--primary {
    background: $light-aqua;
    border-color: $light-aqua;

    &:hover {
      background: $light-aqua-hover;
      box-shadow: 0 2px 5px $gray-section;
    }
  }

  &:disabled {
    pointer-events: none;
    opacity: 0.6;
  }
}
</style>
